const light = {
	50: '#f3fdeb',
	100: '#d3e7bd',
	200: '#deffc5',
	300: '#96b171',
	400: '#9aa76b',
	500: '#81a75e',
	600: '#7aa75c',
	700: '#7fa75a',
	800: '#7ca754',
	900: '#81a74f',
	A100: '#ffffff',
	A200: '#ffffff',
	A400: '#e9fdd7',
	A700: '#e7ffd2'
};

export default light;
